import React from "react";
import submit from "submit-form";
import PropTypes from "prop-types";

const EnableCommunityChat = ({ isPush, isPress, isPull }) => {
  const parts = [];
  if (isPush) parts.push("subscribers");
  if (isPress) parts.push("members");
  if (isPull) parts.push("clients");
  const audienceLabel = parts.length > 0 ? parts.join(" and ") : "users";

  /**
   * Function to open the external link with more community chat information
   */
  const handleOpenLink = () => {
    const url =
      "https://msbapp.notion.site/Community-Chat-152e68dcd77680e2878fd70836f8266b?pvs=4";
    if (typeof window !== "undefined") {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  /**
   * Function to enable community chat
   */
  const handleEnableCommunityChat = (e) => {
    e.preventDefault();
    submit(`/actions/user/enable-community-chat`, {
      method: "POST",
      body: {},
    });
  };

  return (
    <div className="enable-community-chat-main">
      <div>
        <img src="/img/new-icons/undraw_community_chat.svg" alt="new" />
      </div>
      <div className="flex flex-col text-center mt-8 mb-12 gap-4 max-w-104">
        <span className="font-bold text-[1.125rem]">Community Chat</span>
        <span className="opacity-70 text-[0.875rem]">
          Build stronger connections with your app {audienceLabel} and create an
          engaging environment where clients feel motivated and supported. The
          Community Chat feature helps you streamline communication, foster
          accountability, and inspire your clients—all within your app.
        </span>
      </div>
      <div className="enable-community-chat-buttons">
        <button onClick={handleEnableCommunityChat} data-button-type="primary">
          <span>Enable Community Chat</span>
        </button>
        <button data-button-type="secondary" onClick={handleOpenLink}>
          Learn More
        </button>
      </div>
    </div>
  );
};

EnableCommunityChat.propTypes = {
  isPush: PropTypes.bool,
  isPress: PropTypes.bool,
  isPull: PropTypes.bool,
};

export default EnableCommunityChat;
